import { UtilitiesService } from './../../services/utilities.service';
import { DefaultResponse } from './../../models/form/DefaultResponse';
import { ResearchActions } from './research.action';
import { ResearchAdviceLite } from '../../models/research/research-opportunity.model';
import { RecommendationCategory } from '../../models/research/research-category.model';

export class ResearchState {
    public index: any[];
    public loadingIndex: boolean;
    public indexAgregated: any[];
    public indexQuote: DefaultResponse;
    public pending: boolean;
    public error: any;
    public taxTable: Array<{id: number; numberDays: number; taxValue: number}>;
    public taxTablePending: boolean;
    public priceBand: any;
    public advice: ResearchAdviceLite;
    public opportunities: ResearchAdviceLite[];
    public categories: RecommendationCategory[];
    public loadingCategories: boolean;
    public opportunity: ResearchAdviceLite;
    public pendingPrice: string[];
}

export const initialGenericState: ResearchState = {
    index: null,
    loadingIndex: false,
    indexAgregated: null,
    indexQuote: null,
    pending: false,
    error: null,
    taxTable: null,
    taxTablePending: false,
    priceBand: {},
    advice: null,
    opportunities: null,
    opportunity: null,
    pendingPrice: [],
    categories: [],
    loadingCategories: false,
};

export function ResearchReducer(state: ResearchState = initialGenericState, action: any): ResearchState {

    switch (action.type) {

        case ResearchActions.getIndex:
            return { ...{}, ...state, ...{ loadingIndex: true, pending: true, error: null } };
        case ResearchActions.getIndexSuccess:
            return { ...{}, ...state, ...{ loadingIndex: false, pending: false, error: null, index: [...action.payload] } };
        case ResearchActions.getIndexError:
            return { ...{}, ...state, ...{ loadingIndex: false, pending: false, error: action.payload } };

        case ResearchActions.getIndexQuote:
            return { ...{}, ...state, ...{ pending: true, error: null } };
        case ResearchActions.getIndexQuoteSuccess:
            return { ...{}, ...state, ...{ pending: false, error: null, indexQuote: action.payload } };
        case ResearchActions.getIndexQuoteError:
            return { ...{}, ...state, ...{ pending: false, error: action.payload } };

        case ResearchActions.getTaxTable:
            return { ...state, ...{ taxTablePending: true } };
        case ResearchActions.getTaxTableSuccess:
            return { ...state, ...{ taxTablePending: false, taxTable: action.payload } };
        case ResearchActions.getTaxTableError:
            return { ...state, ...{ taxTablePending: false, error: action.payload } };

        case ResearchActions.getIndexAgregated:
            return { ...state, ...{ pending: true } };
        case ResearchActions.getIndexAgregatedSuccess:
            return { ...state, ...{ pending: false, indexAgregated: [...action.payload] } };
        case ResearchActions.getIndexAgregatedError:
            return { ...state, ...{ pending: false, error: action.payload } };

        case ResearchActions.getPriceBands:
            return { ...state, ...{ pending: true, pendingPrice: [...state.pendingPrice, action.payload] }};
        case ResearchActions.getPriceBandsSuccess:
            return { ...state, ...{
                        pending: state.pendingPrice.filter((item) => item !== action.payload.symbolID).length === 0,
                        priceBand: UtilitiesService.mergeIndexableObject(state.priceBand, [action.payload], 'symbolID'),
                        pendingPrice: state.pendingPrice.filter((item) => item !== action.payload.symbolID),
                    },
                };
        case ResearchActions.getPriceBandsError:
            return { ...state, ...{
                    pending: state.pendingPrice.filter((symbol) => symbol !== action.payload.symbolID).length === 0,
                    pendingPrice: state.pendingPrice.filter((symbol) => symbol !== action.payload.symbolID),
                    error: action.payload.error,
                },
            };

        case ResearchActions.getOpportunities:
            return { ...state, ...{ pending: true } };
        case ResearchActions.getOpportunitiesSuccess:
            return { ...state, ...{ pending: false, opportunities: action.payload } };
        case ResearchActions.getOpportunitiesError:
            return { ...state, ...{ pending: false, error: action.payload } };

        case ResearchActions.getOpportunity:
            return { ...state, ...{ pending: true } };
        case ResearchActions.getOpportunitySuccess:
            return { ...state, ...{ pending: false, opportunity: action.payload } };
        case ResearchActions.getOpportunityError:
            return { ...state, ...{ pending: false, error: action.payload, opportunity: null } };

        case ResearchActions.reasearchAdvicesSubscribe:
            return { ...state, ...{ pending: true } };
        case ResearchActions.reasearchAdvicesSubscribeSuccess:
            return { ...state, ...{ pending: false, advice: action.payload } };
        case ResearchActions.reasearchAdvicesSubscribeError:
            return { ...state, ...{ pending: false, error: action.payload } };
        case ResearchActions.reasearchCleanAdvice:
            return { ...state, ...{ pending: false, advice: null } };

        case ResearchActions.loadCategories:
            return {
                ...state,
                ...{
                    loadingCategories: true,
                },
            };
        case ResearchActions.loadCategoriesSuccess:
            return {
                ...state,
                ...{
                    loadingCategories: false,
                    categories: action.payload,
                },
            };

        case ResearchActions.loadCategoriesError:
            return {
                ...state,
                ...{
                    loadingCategories: false,
                    error: action.payload,
                },
            };

        case ResearchActions.mergeNewCategory:
            return {
                ...state,
                ...{
                    categories: state.categories.concat([action.payload]),
                },
            };

        default:
            return state;
    }

}
